import { apiClient } from './apiClient';

export interface Appeal {
  appealId: string;
  postId: string;
  userId: string;
  reason: string;
  status: 'pending' | 'approved' | 'rejected';
  adminNote?: string;
  reviewedBy?: string;
  reviewedAt?: number;
  createdAt: number;
}

export const appealService = {
  submit: async (postId: string, reason: string) => {
    return apiClient.post<{ success: boolean; appeal: Appeal }>('/api/v1/appeals', { postId, reason });
  },

  getMyAppeals: async () => {
    return apiClient.get<{ appeals: Appeal[] }>('/api/v1/appeals/my');
  },

  // Admin
  getPending: async () => {
    return apiClient.get<{ appeals: Appeal[] }>('/api/v1/appeals/pending');
  },

  getAll: async (status?: string) => {
    const query = status ? `?status=${status}` : '';
    return apiClient.get<{ appeals: Appeal[] }>(`/api/v1/appeals/all${query}`);
  },

  approve: async (appealId: string, adminNote?: string) => {
    return apiClient.put<{ success: boolean }>(`/api/v1/appeals/${appealId}/approve`, { adminNote });
  },

  reject: async (appealId: string, adminNote?: string) => {
    return apiClient.put<{ success: boolean }>(`/api/v1/appeals/${appealId}/reject`, { adminNote });
  },
};
